<div class="upload-container">
  <img [src]="image" (click)="uploader.click()" *ngIf="image" alt="" class="img-preview" />
  <input type='file' accept="image/*" (change)="previewUploadFile($event)" #uploader hidden />
  <a *ngIf="showUploadButton" class="btn btn-dark bg-lightgray bold" (click)="uploader.click()">
    <i class="fas fa-file-upload pr-3" aria-hidden="true"></i>Upload {{ label }}
  </a>
</div>